module.exports = "<div [@flyInOut]=\"'in'\" routerLink=\"{{ routerLink ? [routerLink] : [] }}\" class=\"tile {{ color }}\">\n    <h3 class=\"title\">{{ title }}</h3>\n    <div class=\"row tile-icon\">\n        <span class=\"fa-stack fa-lg\">\n            <i class=\"fa fa-square-o fa-stack-2x\"></i>\n            <i class=\"fa {{ icon }} fa-stack-1x\"></i>\n        </span>\n    </div>\n    <p>{{ description }}</p>\n</div>\n\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/components/tile/tile.component.html
// module id = 972
// module chunks = 0